import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useEffect, useState } from 'react';
import Modal from '../modal/Modal';
import { RichText, Text } from '@sitecore-jss/sitecore-jss-react';
import { Button } from 'react-bootstrap';
import { connect } from 'react-redux';
import { loyaltyDuck } from '../../ducks/loyalty';

var LoginErrorMessage = function LoginErrorMessage(props) {
  var _props$loyalty2, _primaryButton$value, _primaryButton$value2;

  var _props$model = props.model,
      model = _props$model === void 0 ? {} : _props$model;
  var header = model.header,
      copy = model.copy,
      primaryButton = model.primaryButton,
      secondaryButton = model.secondaryButton;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  useEffect(function () {
    var _props$loyalty;

    if ((_props$loyalty = props.loyalty) === null || _props$loyalty === void 0 ? void 0 : _props$loyalty.hasLoginError) {
      setIsOpen(true);
    }
  }, [(_props$loyalty2 = props.loyalty) === null || _props$loyalty2 === void 0 ? void 0 : _props$loyalty2.hasLoginError]);

  var handleHide = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setIsOpen(false);
              props.setErrorMessage(false);
              window.location = "/";

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleHide() {
      return _ref.apply(this, arguments);
    };
  }(); // Uncomment this to test on storybook

  /*     useEffect(() => {
          setIsOpen(true)
      }, []) */


  return /*#__PURE__*/React.createElement(Modal, {
    className: 'loyalty-modal loyalty-modal--login-error',
    show: isOpen,
    hide: handleHide,
    hideCloseButton: true,
    backdrop: true,
    noHeader: true
  }, /*#__PURE__*/React.createElement("div", {
    className: 'cb-login-error-modal'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'cb-login-error-modal__body-container'
  }, /*#__PURE__*/React.createElement(Text, {
    tag: 'span',
    className: 'cb-login-error-modal__body-container__header',
    field: header
  }), /*#__PURE__*/React.createElement(RichText, {
    field: copy,
    tag: "span",
    className: 'cb-login-error-modal__body-container__copy'
  }), /*#__PURE__*/React.createElement(Button, {
    className: "cb-button-primary cb-login-error-modal__body-container__button",
    onClick: handleHide,
    href: primaryButton === null || primaryButton === void 0 ? void 0 : (_primaryButton$value = primaryButton.value) === null || _primaryButton$value === void 0 ? void 0 : _primaryButton$value.href
  }, primaryButton === null || primaryButton === void 0 ? void 0 : (_primaryButton$value2 = primaryButton.value) === null || _primaryButton$value2 === void 0 ? void 0 : _primaryButton$value2.text), /*#__PURE__*/React.createElement(Button, {
    className: "cb-button-secondary cb-login-error-modal__body-container__button",
    onClick: handleHide
  }, secondaryButton === null || secondaryButton === void 0 ? void 0 : secondaryButton.value))));
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    loyalty: state.loyalty
  };
};

var loyaltyOperations = loyaltyDuck.operations;

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    setErrorMessage: function setErrorMessage(show) {
      return dispatch(loyaltyOperations.setErrorMessage(show));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LoginErrorMessage);